import { createTheme } from "@mui/material/styles";
import { ThemeOptions } from "@mui/material/styles/createTheme";
import { GlobalTheme } from "./config";
import { setThemeBarColors } from "../utils";
import moment from "moment";

export const getTenant = () => {
  let hostname = window.location.hostname;
  let faviconPath, name, title, copyRightText, httpHeader, ios, android, slug;
  let logo = { width: 0, height: 0, position: "left" };

  let subdomain = "localhost";
  if (hostname.includes("rejeem")) {
    subdomain = "rejeem";
  }
  if (hostname.includes("healthy-kitchen")) {
    subdomain = "healthy-kitchen";
  }
  if (hostname.includes("second-bite")) {
    subdomain = "second-bite";
  }
  if (hostname.includes("diet-center")) {
    subdomain = "diet-center";
  }
  if (["low-cal", "low-calories", "lowcalories"].some((i) => hostname.includes(i))) {
    subdomain = "low-cal";
  }
  if (hostname.includes("high-protein")) {
    subdomain = "high-protein";
  }

  switch (subdomain) {
    case "healthy-kitchen":
      httpHeader = "healthy-kitchen";
      title = "Healthy Kitchen";
      name = "healthy-kitchen";
      slug = "healthy-kitchen";
      copyRightText = `© ${moment().year()} Healthy Kitchen. All rights reserved.`;
      ios = "https://apps.apple.com/tr/app/healthy-kitchen-doha/id6742196670";
      android = "https://play.google.com/store/apps/details?id=com.healthykitchen.app";
      logo.width = 160;
      logo.height = 60;
      logo.position = "center";
      break;
    case "second-bite":
      httpHeader = "second-bite";
      title = "Second Bite";
      name = "second-bite";
      slug = "second-bite";
      copyRightText = `© ${moment().year()} Second Bite. All rights reserved.`;
      ios = "https://apps.apple.com/tr/app/secondbite-qa/id6741466602";
      android = "https://play.google.com/store/apps/details?id=com.secondbite.app";
      logo.width = 200;
      logo.height = 40;
      logo.position = "center";
      break;
    case "diet-center":
      httpHeader = "diet-center";
      title = "Diet Center";
      name = "diet-center";
      slug = "diet-center";
      copyRightText = `© ${moment().year()} Diet Center. All rights reserved.`;
      ios = "https://apps.apple.com/tr/app/diet-center-qatar/id6741466885";
      android = "https://play.google.com/store/apps/details?id=com.dietcenter.app";
      logo.width = 130;
      logo.height = 70;
      logo.position = "center";
      break;
    case "low-cal":
      httpHeader = "low-cal";
      title = "Low Cal";
      name = "low-cal";
      slug = "low-calories";
      copyRightText = `© ${moment().year()} Low Cal. All rights reserved.`;
      ios = "https://apps.apple.com/tr/app/low-calories-qa/id6741466798";
      android = "https://play.google.com/store/apps/details?id=com.lowcal.app";
      logo.width = 150;
      logo.height = 60;
      logo.position = "center";
      break;
    case "high-protein":
      httpHeader = "high-protein";
      title = "High Protein";
      name = "high-protein";
      slug = "high-protein";
      copyRightText = `© ${moment().year()} High Protein. All rights reserved.`;
      ios = "https://apps.apple.com/tr/app/high-protein/id6741475150";
      android = "https://play.google.com/store/apps/details?id=com.highprotein.app";
      logo.width = 135;
      logo.height = 55;
      logo.position = "center";
      break;
    default:
      httpHeader = "rejeem";
      title = "Rejeem";
      name = "rejeem";
      slug = "rejeem";
      copyRightText = `© ${moment().year()} Rejeem. All rights reserved.`;
      ios = "https://apps.apple.com/us/app/rejeem-healthy-diet-plan/id6470381233";
      android = "https://play.google.com/store/apps/details?id=com.rejeem.app";
      logo.width = 200;
      logo.height = 35;
      logo.position = "left";
      break;
  }

  return {
    httpHeader,
    title,
    name,
    slug,
    copyRightText,
    logo,
    android,
    ios,
  };
};

let themeObject: ThemeOptions;
let faviconPath = "";

const tenant = getTenant();
const subdomain = tenant.name;

switch (subdomain) {
  case "healthy-kitchen":
    faviconPath = "/healthy-kitchen/logo.svg";
    themeObject = GlobalTheme["healthyKitchen"];
    break;
  case "second-bite":
    faviconPath = "/second-bite/logo.svg";
    themeObject = GlobalTheme["secondBite"];
    break;
  case "diet-center":
    faviconPath = "/diet-center/logo.svg";
    themeObject = GlobalTheme["dietCenter"];
    break;
  case "low-cal":
    faviconPath = "/low-cal/logo.svg";
    themeObject = GlobalTheme["lowCal"];
    break;
  case "high-protein":
    faviconPath = "/high-protein/logo.svg";
    themeObject = GlobalTheme["highProtein"];
    break;
  default:
    faviconPath = "/rejeem/favicon.ico";
    themeObject = GlobalTheme["default"];
    break;
}

const doc = document.documentElement;

//update favicon
const link = document.querySelector("link[rel~='icon']");
//@ts-ignore
link.href = `${faviconPath}`;

// Status bar color — defaults to the tenant primary, kept in sync across web
// (theme-color meta) and the mobile apps (native bridge). Bottom bar is white.
export const defaultThemeBarColor = String(themeObject.palette?.text?.primaryDefault);
setThemeBarColors(defaultThemeBarColor);

// update site title
document.title = tenant.title;

//@ts-ignore
doc.style.setProperty("--font-family", String(themeObject.typography.fontFamily));

//@ts-ignore
doc.style.setProperty("--primary", String(themeObject.palette?.primary?.main));
//@ts-ignore
doc.style.setProperty("--primary-text", String(themeObject.palette?.primary?.text));
//@ts-ignore
doc.style.setProperty("--secondary-text", String(themeObject.palette?.secondary?.text));

doc.style.setProperty("--primary-lighter", String(themeObject.palette?.text?.primaryLighter));
doc.style.setProperty("--primary-light", String(themeObject.palette?.text?.primaryLight));
doc.style.setProperty("--primary-default", String(themeObject.palette?.text?.primaryDefault));
doc.style.setProperty("--primary-dark", String(themeObject.palette?.text?.primaryDark));
doc.style.setProperty("--primary-darkest", String(themeObject.palette?.text?.primaryDarkest));

doc.style.setProperty("--secondary-lighter", String(themeObject.palette?.text?.secondaryLighter));
doc.style.setProperty("--secondary-light", String(themeObject.palette?.text?.secondaryLight));
doc.style.setProperty("--secondary-default", String(themeObject.palette?.text?.secondaryDefault));
doc.style.setProperty("--secondary-dark", String(themeObject.palette?.text?.secondaryDark));
doc.style.setProperty("--secondary-darkest", String(themeObject.palette?.text?.secondaryDarkest));

doc.style.setProperty("--success-lighter", String(themeObject.palette?.text?.successLighter));
doc.style.setProperty("--success-light", String(themeObject.palette?.text?.successLight));
doc.style.setProperty("--success-default", String(themeObject.palette?.text?.successDefault));
doc.style.setProperty("--success-dark", String(themeObject.palette?.text?.successDark));
doc.style.setProperty("--success-darkest", String(themeObject.palette?.text?.successDarkest));

doc.style.setProperty("--error-lighter", String(themeObject.palette?.text?.errorLighter));
doc.style.setProperty("--error-light", String(themeObject.palette?.text?.errorLight));
doc.style.setProperty("--error-default", String(themeObject.palette?.text?.errorDefault));
doc.style.setProperty("--error-dark", String(themeObject.palette?.text?.errorDark));
doc.style.setProperty("--error-darkest", String(themeObject.palette?.text?.errorDarkest));

doc.style.setProperty("--warning-lighter", String(themeObject.palette?.text?.warningLighter));
doc.style.setProperty("--warning-light", String(themeObject.palette?.text?.warningLight));
doc.style.setProperty("--warning-default", String(themeObject.palette?.text?.warningDefault));
doc.style.setProperty("--warning-dark", String(themeObject.palette?.text?.warningDark));
doc.style.setProperty("--warning-darkest", String(themeObject.palette?.text?.warningDarkest));

doc.style.setProperty("--info-lighter", String(themeObject.palette?.text?.infoLighter));
doc.style.setProperty("--info-light", String(themeObject.palette?.text?.infoLight));
doc.style.setProperty("--info-default", String(themeObject.palette?.text?.infoDefault));
doc.style.setProperty("--info-dark", String(themeObject.palette?.text?.infoDark));
doc.style.setProperty("--info-darkest", String(themeObject.palette?.text?.infoDarkest));

doc.style.setProperty("--base-50", String(themeObject.palette?.text?.base50));
doc.style.setProperty("--base-100", String(themeObject.palette?.text?.base100));
doc.style.setProperty("--base-200", String(themeObject.palette?.text?.base200));
doc.style.setProperty("--base-300", String(themeObject.palette?.text?.base300));
doc.style.setProperty("--base-400", String(themeObject.palette?.text?.base400));
doc.style.setProperty("--base-500", String(themeObject.palette?.text?.base500));
doc.style.setProperty("--base-600", String(themeObject.palette?.text?.base600));
doc.style.setProperty("--base-700", String(themeObject.palette?.text?.base700));
doc.style.setProperty("--base-800", String(themeObject.palette?.text?.base800));
doc.style.setProperty("--base-850", String(themeObject.palette?.text?.base850));
doc.style.setProperty("--base-900", String(themeObject.palette?.text?.base900));
doc.style.setProperty("--base-950", String(themeObject.palette?.text?.base950));

doc.style.setProperty("--font-lighter", String(themeObject.palette?.text?.fontLighter));
doc.style.setProperty("--font-light", String(themeObject.palette?.text?.fontLight));
doc.style.setProperty("--font-default", String(themeObject.palette?.text?.fontDefault));
doc.style.setProperty("--font-dark", String(themeObject.palette?.text?.fontDark));
doc.style.setProperty("--font-darkest", String(themeObject.palette?.text?.fontDarkest));

doc.style.setProperty("--body-bg", String(themeObject.palette?.text?.bodyBg));
doc.style.setProperty("--fire-color", String(themeObject.palette?.text?.fire));
doc.style.setProperty("--white", String(themeObject.palette?.text?.white));

// doc.style.setProperty("--pro-gradient: linear-gradient(135deg, #ffe70b 0%, #ff8f0b 100%);
// doc.style.setProperty("--pro-color: #ff980b;
// doc.style.setProperty("--custom-gradient: linear-gradient(0deg, #ff9e0c 0%, #ffb309 100%);

export const theme = createTheme(themeObject);

export default theme;
